<template>
  <div v-if="isOpen" :class="$style.imageModal">
    <div :class="$style.overlay" @click="$emit('close')"></div>
    <div :class="$style.content" @click.stop>
      <div :class="$style.top">
        <div :class="$style.close" @click.stop="$emit('close')">
          <img src="/icons/common/cross-black.svg" alt="" />
        </div>
        Фото комментария
      </div>
      <div :class="$style.body">
        <div :class="$style.link">
          <a :href="comment.map_url" target="_blank"
            >Открыть карту по координатам:
            {{ comment.coordinates?.coordinates?.join(", ") }}</a
          >
        </div>
        <div :class="$style.image">
          <img :src="image" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    comment: {
      type: Object,
      default: () => ({}),
    },
    image: {
      type: String,
      default: "",
    },
  },
  emits: ["close"],
};
</script>

<style lang="scss" module>
@keyframes expand {
  from {
    transform: scale(0.7);
    opacity: 0;
  }
}
.imageModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 70;
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(1.25rem);
    transition: opacity 0.3ms;
    z-index: 70;
    animation: expand 0.2s ease-in-out;
  }
  .content {
    position: fixed;
    left: 50%;
    top: 50%;
    max-height: calc(100vh - 4rem);
    overflow: auto;
    @include scrollbarY;
    transform: translate(-50%, -50%);
    background-color: $bg-white;
    border-radius: 2rem;
    z-index: 70;
    animation: expand 0.2s ease-in-out;
    width: 40rem;
    .top {
      position: relative;
      padding: 1.5rem 0 0 0;
      text-align: center;
      font-size: 1.25rem;
      .close {
        position: absolute;
        right: 0;
        top: 0;
        img {
          padding: 1rem;
          cursor: pointer;
        }
      }
    }
    .body {
      padding: 1.5rem;
      .link {
        margin: 0 0 1.5rem 0;
        color: $blue;
      }
      .image {
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>

